module.exports = __webpack_public_path__ + "static/media/image-affordable.bc1410fb.jpg";